import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faFacebook,
  faInstagram,
  faLinkedin,
  faFacebookF,
  faFacebookSquare,
  faGooglePlusG,
  faGulp,
  faHotjar,
  faLinkedinIn,
  faMediumM,
  faNodeJs,
  faSass,
  faTrello,
  faTwitter,
  faYoutube
} from '@fortawesome/free-brands-svg-icons';
import {
  faCircle as farCircle,
  faClock as farClock,
  faComment as farComment,
  faCopy as farCopy,
  faDizzy as farDizzy,
  faFile as farFile,
  faFileArchive as farFileArchive,
  faFileAudio as farFileAudio,
  faFileCode as farFileCode,
  faFileImage as farFileImage,
  faFilePdf as farFilePdf,
  faFileVideo as farFileVideo,
  faHeart as farHeart,
  faImage as farImage,
  faLaughBeam as farLaughBeam,
  faLightbulb as farLightbulb,
  faObjectUngroup as farObjectUngroup,
  faPaperPlane as farPaperPlane,
  faQuestionCircle as farQuestionCircle,
  faSmileBeam as farSmileBeam,
  faStar as farStar
} from '@fortawesome/free-regular-svg-icons';
import {
  faAlignLeft,
  faAlignRight,
  faAngleLeft,
  faAngleRight,
  faArchive,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowsAltV,
  faArrowUp,
  faAt,
  faBan,
  faBell,
  faBook,
  faBox,
  faCalendarAlt,
  faCalendarCheck,
  faCamera,
  faCaretDown,
  faCaretRight,
  faCaretUp,
  faCartPlus,
  faChartPie,
  faCheck,
  faCheckCircle,
  faCheckDouble,
  faCheckSquare,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleNotch,
  faClock,
  faCodeBranch,
  faCopyright,
  faCog,
  faComments,
  faCopy,
  faCrown,
  faUserLock,
  faDollarSign,
  faCommentDollar,
  faEdit,
  faEllipsisH,
  faEllipsisV,
  faEnvelope,
  faEnvelopeOpen,
  faExchangeAlt,
  faExclamation,
  faExclamationCircle,
  faExclamationTriangle,
  faExternalLinkAlt,
  faEye,
  faFile,
  faFileAlt,
  faFileArchive,
  faFilePdf,
  faFilter,
  faFlask,
  faFolderPlus,
  faGift,
  faGlobeAmericas,
  faHeart,
  faHome,
  faIcons,
  faImage,
  faInfo,
  faLink,
  faList,
  faListAlt,
  faListUl,
  faLocationArrow,
  faLock,
  faMinus,
  faMinusCircle,
  faMapMarkerAlt,
  faPalette,
  faPaperclip,
  faPencilAlt,
  faPen,
  faPercentage,
  faPhone,
  faPlay,
  faPlug,
  faPlus,
  faPlusCircle,
  faPlusSquare,
  faPoll,
  faPrint,
  faPuzzlePiece,
  faQuestionCircle,
  faRedo,
  faShapes,
  faReply,
  faSearch,
  faShare,
  faShareAlt,
  faShoppingCart,
  faSignInAlt,
  faSlidersH,
  faSmileBeam,
  faSort,
  faSortAlphaDown,
  faSortAlphaUp,
  faSortAmountDown,
  faSortAmountUp,
  faSortNumericDown,
  faSortNumericUp,
  faStar,
  faStarHalfAlt,
  faStream,
  faTag,
  faTh,
  faThumbsUp,
  faTimes,
  faTimesCircle,
  faTools,
  faTrash,
  faTrashAlt,
  faUser,
  faUserCircle,
  faUserFriends,
  faUserPlus,
  faUsers,
  faVideo,
  faCross,
  faAnchor,
  faArrowCircleLeft,
  faArrowCircleRight,
  faHandHoldingHeart,
  faHandPaper,
  faHiking,
  faRunning,
  faBullhorn,
  faGraduationCap,
  faChalkboardTeacher,
  faMusic,
  faDoorOpen,
  faGlasses,
  faUsersCog,
  faInfoCircle,
  faArrowAltCircleUp,
  faArrowAltCircleDown,
  faCode,
  faSyncAlt,
  faCloudDownloadAlt,
  faClone,
  faDownload,
  faFlagCheckered,
  faFistRaised,
  faTicketAlt,
  faSave,
  faGripVertical,
  faEyeSlash,
  faCaretSquareDown,
  faShareSquare,
  faArrowCircleDown,
  faMoneyBillWave,
  faCreditCard,
  faUserCheck,
  faPauseCircle,
  faLockOpen,
  faStethoscope,
  faPeopleArrows,
  faStore,
  faQrcode,
  faSpinner,
  faUpload,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faSortUp,
  faSortDown,
  faHeartbeat,
  faStickyNote,
  faStopwatch,
  faHourglassHalf,
  faKey,
  faIdCard,
  
} from '@fortawesome/free-solid-svg-icons';

library.add(
  // Solid
  faStore,
  faUpload,
  faSpinner,
  faQrcode,
  faPeopleArrows,
  faCommentDollar,
  faCaretSquareDown,
  faEyeSlash,
  faGripVertical,
  faSave,
  faBullhorn,
  faChartPie,
  faAnchor,
  faCopy,
  faSearch,
  faHome,
  faBell,
  faPlay,
  faChevronRight,
  faChevronLeft,
  faChevronUp,
  faChevronDown,
  faExchangeAlt,
  faAngleRight,
  faAngleLeft,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faSortUp,
  faSortDown,
  faEllipsisH,
  faCrown,
  faUserLock,
  faListAlt,
  faCheck,
  faBan,
  faStream,
  faArrowsAltV,
  faSort,
  faSortAlphaDown,
  faSortAlphaUp,
  faSortNumericDown,
  faSortNumericUp,
  faSortAmountDown,
  faCopyright,
  faSortAmountUp,
  faCheckCircle,
  faUserCircle,
  faQuestionCircle,
  faLock,
  faCircle,
  faHeart,
  faShareAlt,
  faCaretRight,
  faArrowDown,
  faArrowUp,
  faArrowLeft,
  faArrowRight,
  faPrint,
  faDollarSign,
  faLink,
  faPlus,
  faPlusCircle,
  faMinus,
  faMinusCircle,
  faUser,
  faPencilAlt,
  faPen,
  faCamera,
  faTimesCircle,
  faSignInAlt,
  faBook,
  faBox,
  faPuzzlePiece,
  faTrash,
  faAlignLeft,
  faAlignRight,
  faPlug,
  faTimes,
  faFilter,
  faExternalLinkAlt,
  faCartPlus,
  faShoppingCart,
  faStar,
  faStarHalfAlt,
  faArchive,
  faEnvelope,
  faClock,
  faStar,
  faReply,
  faLocationArrow,
  faCog,
  faUsersCog,
  faPaperclip,
  faImage,
  faEllipsisV,
  faEnvelopeOpen,
  faRedo,
  faShapes,
  faSlidersH,
  faTrashAlt,
  faFile,
  faFileArchive,
  faFilePdf,
  faFileAlt,
  faEye,
  faFlask,
  faCaretUp,
  faCodeBranch,
  faExclamationTriangle,
  faListUl,
  faTh,
  faGift,
  faUsers,
  faGlobeAmericas,
  faPlusSquare,
  faCaretDown,
  faUserPlus,
  faCircleNotch,
  faExclamation,
  faThumbsUp,
  faComments,
  faPalette,
  faEdit,
  faTrashAlt,
  faShare,
  faCheckSquare,
  faTools,
  faCheckDouble,
  faSmileBeam,
  faPoll,
  faPercentage,
  faIcons,
  faList,
  faUserFriends,
  faExclamationCircle,
  faFolderPlus,
  faTag,
  faAt,
  faCalendarAlt,
  faCalendarCheck,
  faMapMarkerAlt,
  faCross,
  faArrowCircleLeft,
  faArrowCircleRight,
  faArrowCircleDown,
  faHandHoldingHeart,
  faHandPaper,
  faHiking,
  faRunning,
  faGraduationCap,
  faChalkboardTeacher,
  faMusic,
  faDoorOpen,
  faGlasses,
  faInfoCircle,
  faArrowAltCircleUp,
  faArrowAltCircleDown,
  faCode,
  faCloudDownloadAlt,
  faDownload,
  faSyncAlt,
  faClone,
  faFlagCheckered,
  faFistRaised,
  faTicketAlt,
  faShareSquare,
  faUserCheck,
  faPauseCircle,
  faLockOpen,
  faStethoscope,
  faUpload,
  faHeartbeat,
  faStickyNote,
  faKey,
  faIdCard,

  // Brand
  faFacebook,
  faInstagram,
  faLinkedin,
  faFacebookF,
  faFacebookSquare,
  faGulp,
  faNodeJs,
  faSass,
  faTwitter,
  faGooglePlusG,
  faLinkedinIn,
  faMediumM,
  faHotjar,
  faYoutube,
  faVideo,
  faInfo,
  faPhone,
  faTrello,

  // Regular
  farHeart,
  farLightbulb,
  farObjectUngroup,
  farPaperPlane,
  farStar,
  farImage,
  farFileArchive,
  farFilePdf,
  farFile,
  farFileVideo,
  farFileAudio,
  farFileImage,
  farFileCode,
  farClock,
  farQuestionCircle,
  farDizzy,
  farLaughBeam,
  farSmileBeam,
  farCircle,
  farCopy,
  farComment,
  faCreditCard,
  faMoneyBillWave,
  faStopwatch,
  faHourglassHalf,
);
